import CommitmentActivity from './CommitmentsActivity';
export default CommitmentActivity;
